// 移动端组件
import Vue from 'vue'
import { Button, Popup, Notify, Loading, PullRefresh, Toast, Sticky } from 'vant-green';
// import 'vant-green/lib/index.css';

Vue.use(Button)
Vue.use(Popup)
Vue.use(Notify)
Vue.use(Loading)
Vue.use(PullRefresh)
Vue.use(Toast)
Vue.use(Sticky)
